import ProductIcon from '@mui/icons-material/Collections';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
    value?: string;
}

const ClosingOfSharesPending = (props: Props) => {
    const { value } = props;
    const translate = useTranslate();
    return (
        <CardWithIcon
            to='/closingOfShares?filter={"sendToResponsibleForClosingOfActions":true,"sendToResponsibleForVerificationEffectivenessAction":false,"closeDate":null}'
            icon={ProductIcon}
            title={translate('resources.dashboard.closingOfSharesPending')}
            subtitle={value}
        />
    );
};

export default ClosingOfSharesPending;